import React, { Component } from 'react';
import Grid from "@material-ui/core/Grid";
class DefiHeaderLogo extends Component {
  constructor() {
    super(...arguments);
    this.renderImage = () => {
      const className = this.props.className;
      const src = localStorage.logo ? localStorage.logo : "/Home/GetLogo";
      return /*#__PURE__*/React.createElement("img", {
        src: src,
        alt: "logo",
        className: className
      });
    };
  }
  render() {
    const _this$props = this.props,
      logo = _this$props.logo,
      logoLink = _this$props.logoLink;
    const href = logoLink ? logoLink : logo === 'client' ? '/Home/Landing' : null;
    if (href) {
      return /*#__PURE__*/React.createElement("a", {
        id: "logoLink",
        href: href
      }, /*#__PURE__*/React.createElement(Grid, {
        container: true,
        alignItems: "center"
      }, this.renderImage()));
    }
    return this.renderImage();
  }
}
export default DefiHeaderLogo;